import {
  type AssetHolderSummary,
  type EmailNotificationsGroupKeys, type EmailNotificationsStatus
} from '../../api-schema-types/asset-holdings/AssetHolderDomainDtos'
import { type AssetHolderUpdateDto } from '../../api-schema-types/asset-holdings/AssetHolderCrudDtos'

 
export function assetHolderApiMapper () {
  const assetHolderSummaryMapper = (
    responseData: AssetHolderSummary[],
    responseMeta: any,
    responseArgs: any
  ): AssetHolderSummary[] => {
    return responseData
  }

  const assetHolderCrudMapper = (responseData: AssetHolderUpdateDto, meta: any, args: any): AssetHolderUpdateDto => {
    return responseData
  }
  const emailNotificationsGroupKeysMapper = (responseData: EmailNotificationsGroupKeys, meta: any, args: any): EmailNotificationsGroupKeys => {
    return responseData
  }
  const emailNotificationsStatusMapper = (responseData: EmailNotificationsStatus, meta: any, args: any): EmailNotificationsStatus => {
    return responseData
  }

  return {
    assetHolderSummaryMapper,
    emailNotificationsGroupKeysMapper,
    emailNotificationsStatusMapper,
    assetHolderDetailsMapper: assetHolderCrudMapper
  }
}
